import { h } from 'preact';

export function IconCustomContent({ width = 22, height = 22, fill = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={width}
      height={height}
      class="icon-custom-content"
    >
      <path
        d="M325.5 112C329.7 112 333.8 113.7 336.8 116.7L459.3 239.2C462.3 242.2 464 246.3 464 250.5L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112L325.5 112zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64z"
        fill={fill}
      />
    </svg>
  );
}
